import { render, staticRenderFns } from "./MassEmailsForm.vue?vue&type=template&id=da3a8992&scoped=true&"
import script from "./MassEmailsForm.vue?vue&type=script&lang=js&"
export * from "./MassEmailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3a8992",
  null
  
)

export default component.exports